@if (!isAllowed) {
  <div class="grid grid-cols-12 gap-8">
    <div class="surface-ground flex items-center justify-center overflow-hidden">
      <div class="flex flex-column items-center justify-center">
        <div style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, rgba(247, 149, 48, 0.4) 10%, rgba(247, 149, 48, 0) 30%);">
          <div class="surface-card py-8 px-5 sm:px-8 flex flex-column items-center" style="border-radius:53px">
            <div class="grid flex flex-column items-center">
              <div class="flex justify-center items-center bg-orange-500 border-circle" style="width:3.2rem; height:3.2rem;">
                <i class="text-50 pi pi-fw pi-lock text-2xl"></i>
              </div>
              <h1 class="text-900 font-bold text-4xl lg:text-5xl mb-2">Access Denied</h1>
              <span class="text-600 mb-5">You do not have the necessary permisions. Please contact admins.</span>
              <img src="../../../../assets/demo/images/access/asset-access.svg" alt="Access denied" class="mb-5" width="80%">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="grid grid-cols-12 gap-8">
  <project-count class="col-span-12 lg:col-span-6 xl:col-span-3" />
  <user-count class="col-span-12 lg:col-span-6 xl:col-span-3" />
  @if (uuid && uuid!='new') {
    <project-word-count class="col-span-12 lg:col-span-6 xl:col-span-3" />
  }
  @if (!uuid || uuid=='new') {
    <placeholder icolor="cyan" class="col-span-12 lg:col-span-6 xl:col-span-3" />
  }
  <placeholder icolor="purple" class="col-span-12 lg:col-span-6 xl:col-span-3" />
  @if (uuid && uuid=='new' && !selectedBRProject && betaReader.profileGroups && betaReader.profileGroups?.length > 0) {
    <div class="col-span-12 xl:col-span-6">
      <div class="card mb-8!">
        <h5>Available Project Matches</h5>
        <beta-reader-project-matches [betaReader]="betaReader" />
      </div>
    </div>
  }
  @if (uuid && uuid!='new' && selectedProjectMatch) {
    <div class="col-span-12 xl:col-span-6">
      @if (dataService.getSelectedProject()) {
        <div class="card mb-8!">
          <!-- div class="col-span-6">
          <p-button label="Import Document" (click)="displayUploader=true" icon="pi pi-upload" />
          </div -->
          <div class="col-span-6">
            <p-button *ngIf="selectedBRProject.lastInfoRead" (click)="dataService.switchToEditLayout()" label="Review Project" icon="pi pi-pen-to-square" />
                <p-button *ngIf="selectedBRProject.lastInfoRead == null" (click)="showDialog()" label="Review Project" icon="pi pi-pen-to-square" />
                <p-dialog header="Last Info" [modal]="true" [(visible)]="dialogVisible" [style]="{width: '50rem'}">
                    <span class="p-text-secondary block mb-4"><pre style="white-space: pre-wrap;">{{selectedProjectMatch.project.lastInfo}}</pre></span>
                    <div class="justify-end gap-2">
                        <p-button [text]="true" (click)="hideDialog()">Cancel</p-button>
                        <p-button [text]="true" (click)="projectDebug()">Debug</p-button>
                        <p-button [outlined]="true" (click)="saveAndRoute()">Continue</p-button>
                    </div>
                </p-dialog>
          </div>
        </div>
      }
      <div class="card mb-8!">
        <project-display [projectMatch]="selectedProjectMatch" [projectDisplayMode]="ProjectDescriptorUse.BETA_READER_VIEW_OF_PROJECT" />
      </div>
    </div>
  }
  @if (uuid && uuid=='new' && !selectedBRProject) {
    <div [class]="!betaReader.profileGroups || betaReader.profileGroups.length === 0 ? 'xl:col-offset-3':''" class="col-span-12 xl:col-span-6">
      <beta-reader-reading-profile [platformUser]="this.platformUser" [betaReader]="this.betaReader"/>
    </div>
  }
</div>

